'use client'

import React from 'react';
import styled from 'styled-components';
import { Person, Phone, Email, Category, Comment } from '@mui/icons-material';

const FormPage = () => {
  return (
    <StyledWrapper style={{marginRight:'-14px' ,alignItems:'right'}}>
      <form className="form">
        <p id="heading">Contact Us</p>

        <div className="field">
          <Person className="input-icon" />
          <input autoComplete="off" placeholder="Full Name" className="input-field" type="text" />
        </div>

        <div className="field">
          <Phone className="input-icon" />
          <input placeholder="Phone Number" className="input-field" type="tel" />
        </div>

        <div className="field">
          <Email className="input-icon" />
          <input placeholder="Email" className="input-field" type="email" />
        </div>

        

        <div className="field">
          <Comment className="input-icon" />
          <textarea placeholder="Enter your comments" className="input-field" rows="4" />
        </div>

        <div className="btn">
          <button className="button1">Submit</button>
        </div>
      </form>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 1.5em;
    background-color: #ffffff;
    border-radius: 25px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: 0.4s ease-in-out;
    max-width: 450px;
    width: 100%;
    margin: 2em auto;
  }

  #heading {
    text-align: center;
    margin: 0.5em 0;
    color: #171717;
    font-size: 1.4em;
    font-weight: bold;
  }

  .field {
    display: flex;
    align-items: center;
    gap: 0.5em;
    border-radius: 25px;
    padding: 0.7em;
    background-color: #ffffff;
    flex: 1;
    border: 2px solid #DB2777;
  }

  .input-icon {
    color: #DB2777;
    font-size: 1.5em;
  }

  .input-field {
    background: none;
    border: none;
    outline: none;
    width: 100%;
    color: #171717;
    font-size: 1em;
  }

  .btn {
    display: flex;
    justify-content: center;
    margin-top: 1.5em;
  }

  .button1 {
    padding: 0.7em 1.2em;
    border-radius: 5px;
    background-color: #DB2777;
    color: white;
    font-weight: bold;
    border: none;
    outline: none;
    transition: 0.4s ease-in-out;
    text-align: center;
  }

  .button1:hover {
    background-color: #171717;
    color: white;
  }
`;

export default FormPage;